import React, { useState, useEffect, useContext, useMemo } from 'react';
import Layout from './layout';
import "./styles/problems.css"
import Problem from './comps/problem';
import { ENDPOINT, ENDPOINTGO, NetworkCall, ShowNotification } from '../utils/constants';
import Loader from './comps/loader';
import { Context } from '../context';
import Axios from 'axios';
import search from '../utils/searchfrontend';

export default function Problems() {
    const context = useContext(Context)

    const [problems, setProblems] = useState([])

    const fetchProblems = () => {

        Axios.post(ENDPOINT + "/problems")
            .then(res => {
                //randomizing
                let { problems } = res.data
                console.log(problems)
                problems = problems.sort((a, b) => { return Math.floor(Math.random() * 100) })
                setProblems(problems)
                ShowNotification("", 'white', 0)
                context.setProblems(res.data.problems) // saving for route switching
            })
            .catch(err => {
                ShowNotification("Something went wrong :(", 'red', -1)
            })
    }
    useEffect(() => {
        if (!context.problems) {
            ShowNotification("Loading.....", 'white', -1)
            fetchProblems()
        }
        else
            setProblems(context.problems)
    }, [])


    const RenderProblems = () => {
        return (
            problems.map(each => {
                return (
                    <Problem data={each} key={each._id} />
                )
            })
        )
    }

    const [filterObj, setFilterObj] = useState({ difficulty: [], category: [], status: [] })

    const handleSelectFilterDifficulty = (e) => {
        // return
        let temp = { ...filterObj }
        if (!temp.difficulty.includes(e.target.value)) {
            temp.difficulty.push(e.target.value)
        } else {
            let i = temp.difficulty.indexOf(e.target.value)
            temp.difficulty.splice(i, 1)
        }
        setFilterObj(temp)
        console.log(temp)

        filterProblem({ ...temp })
    }
    const filterProblem = async (filterObj_) => {
        if (filterObj_.difficulty.length == 0) {
            filterObj_.difficulty = ['easy', 'medium', 'hard']
        }
        if (filterObj_.category.length == 0) {
            filterObj_.category = ['array', 'linkedlist', 'tree', 'graph', 'dynamic programming', 'backtarcking']
        }
        Axios.post(ENDPOINT + "/problems/filter", filterObj_)
            .then(res => {
                console.log(res.data.problems, ">>>>>>>>>>>>>problems")
                setProblems(res.data.problems)
                // context.setProblems(res.data.problems)
                if (res.data.problems.length == 0) {
                    ShowNotification("No problems :(", "#FFC83D", 3000)
                }
            })
            .catch(err => { })
    }
    const handleSelectFilterCategory = (e) => {
        let temp = { ...filterObj }
        if (!temp.category.includes(e.target.value)) {
            temp.category.push(e.target.value)
        } else {
            let i = temp.category.indexOf(e.target.value)
            temp.category.splice(i, 1)
        }
        setFilterObj(temp)
        console.log(temp)
        filterProblem({ ...temp })
    }


    return (
        <Layout>
            <div className="pb-wrapper">
                {/* <Loader isVisible={!problems.length} entire={true} /> */}
                <div className="pb-box">
                    {problems && problems.length &&
                        <RenderProblems />
                    }
                </div>
                <div className="pb-rightmenu"
                    data-aos="fade-left"
                    data-aos-offset="500"
                    data-aos-duration="500">
                    <span>Filter by -</span>
                    <ol>
                        <li>Difficulty</li>
                        <ul>
                            <li><input type="checkbox" onClick={handleSelectFilterDifficulty} value="easy" />easy</li>
                            <li><input type="checkbox" onClick={handleSelectFilterDifficulty} value="medium" />medium</li>
                            <li><input type="checkbox" onClick={handleSelectFilterDifficulty} value="hard" />hard</li>
                        </ul>
                        {/* <li>Status</li>
                        <ul>
                            <li><input type="checkbox" />solved</li>
                            <li><input type="checkbox" />unsloved</li>
                        </ul> */}
                        <li>Category</li>
                        <ul>
                            <li><input type="checkbox" onClick={handleSelectFilterCategory} value="array" />array</li>
                            <li><input type="checkbox" onClick={handleSelectFilterCategory} value="linkedlist" />linkedlist</li>
                            <li><input type="checkbox" onClick={handleSelectFilterCategory} value="tree" />tree</li>
                            <li><input type="checkbox" onClick={handleSelectFilterCategory} value="graph" />graph</li>
                            <li><input type="checkbox" onClick={handleSelectFilterCategory} value="dynamic programming" />dynamic programming</li>
                            <li><input type="checkbox" onClick={handleSelectFilterCategory} value="backtarcking" />backtracking</li>
                        </ul>
                    </ol>
                </div>
            </div>
        </Layout>
    )
}

const sample = [
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675kpeb1c2a000495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675frdb1c2a000495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a00dew0495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a000de495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a000495addeee23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a00049-05a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a000dssw495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a0004fuck95a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2a0ayusha00495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2sexya000495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1fuckc2a000495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1cher2a000495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2iwanta000495a23c",
    },
    {
        availableLanguage: ["python", "javascript", "c"],
        category: "array",
        difficulty: "easy",
        points: 10,
        problemUrl: "https://res.cloudinary.com/rupamcloud/raw/upload/v1605702759/cp%20code%20templates/160570275903938_problem.md",
        solvedNum: 3,
        title: "Second largest integer",
        tutorialYoutubeLink: "",
        __v: 3,
        _id: "5fb514675b1c2toa000495a23c",
    }
]